import dateUtils from '@utils/DateUtils'

export default class Image {
  constructor (obj) {
    this._isWorkspace = true
    this._bound = obj.bound ? obj.bound : undefined
    this._imageId = obj.image_id ? obj.image_id : undefined
    this._name = obj.name ? obj.name : undefined
    this._imageName = obj.image_name ? obj.image_name : 'None'
    this._owner = obj.owner ? obj.owner : undefined
    this._ownerId = obj.owner_id ? obj.owner_id : undefined
    this._meta = obj.meta ? obj.meta : undefined
    this._modelId = obj.model_id ? obj.model_id : undefined
    this._id = obj.id ? obj.id : undefined
    this._modelName = obj.model_name ? obj.model_name : 'None'
    this._type = obj.type ? obj.type : undefined
    this._workspaceId = obj.workspace_id ? obj.workspace_id : undefined
    this._createdAt = obj.created_at ? dateUtils.convertUTCToLocalDateV2(obj.created_at) : undefined
    this._isRaster = this.checkRaster(obj.type)
    this._createdBy = obj.owner ? obj.owner.name : undefined
    this._categories = obj.categories ? obj.categories : []
  }

  checkRaster (type) {
    if (type === 'raster') return true
    return false
  }
  get categories () {
    return this._categories
  }
  get createdBy () {
    return this._createdBy
  }
  get isRaster () {
    return this._isRaster
  }
  get type () {
    return this._type
  }
  get workspaceId () {
    return this._workspaceId
  }
  get modelName () {
    return this._modelName
  }
  get color () {
    return this._color
  }
  get isWorkspace () {
    return this._isWorkspace
  }
  get bound () {
    return this._bound
  }
  get imageId () {
    return this._imageId
  }
  get imageName () {
    return this._imageName
  }

  get owner () {
    return this._owner
  }
  get ownerId () {
    return this._ownerId
  }
  get meta () {
    return this._meta
  }

  get name () {
    return this._name
  }

  get id () {
    return this._id
  }

  get modelId () {
    return this._modelId
  }

  get createdAt () {
    return this._createdAt
  }
}



// WEBPACK FOOTER //
// ./src/models/dataset/dataset.js